import React from "react"
import { ReactMarkdown } from "react-markdown/lib/react-markdown"

const Content = ({ subtitle, content, map }) => (
	<article className='max-950 ma p20 grey-100'>
		<p className='xlarge pr20 op-75 '>
			<i>{subtitle}</i>
		</p>
		<ReactMarkdown className='lh15 mt60 mb60 press--content large op-75 '>{content}</ReactMarkdown>
		
		{(map ? <div className='mb60' dangerouslySetInnerHTML={{ __html: map }} />:'')} 

	

	</article>
)

export default Content
